import React, { useState, useEffect } from 'react';
import SalesByOrderType from './components/SalesByOrderType';
import ItemsSold from './components/ItemsSold';
import SalesByRegion from './components/SalesByRegion';
import SalesByMainOrderItem from './components/SalesByMainOrderItem';
import NewCustomers from './components/NewCustomers';
import { initializeApp } from 'firebase/app';
import { getAuth, signInWithEmailAndPassword, onAuthStateChanged, signOut } from 'firebase/auth';
import { DbEntryDateProvider } from './contexts/DbEntryDateContext';

// Your Firebase config here
const firebaseConfig = {
  apiKey: 'AIzaSyCsNO2tPFcGrEvfAlc3YwsXwiXip-pWdQs',
  authDomain: 'sd-edm1.firebaseapp.com',
  // ...other config...
};
initializeApp(firebaseConfig);

const auth = getAuth();

// Brand the dashboard per-site based on the URL.
const BRAND_NAME = typeof window !== 'undefined' && window.location.href.includes('busters-sales')
  ? "Buster's Pizza"
  : 'Royal Pizza';

const TABS = [
  { label: 'Sales by Main Order Item', component: <SalesByMainOrderItem /> },
  { label: 'New Customers', component: <NewCustomers /> },
  { label: 'Sales by Order Type', component: <SalesByOrderType /> }/*,
  { label: 'Items Sold', component: <ItemsSold /> },
  { label: 'Sales by Region', component: <SalesByRegion /> },*/
];

function App() {
  const [activeTab, setActiveTab] = useState(0);
  const [user, setUser] = useState(null);
  const [loginEmail, setLoginEmail] = useState('');
  const [loginPassword, setLoginPassword] = useState('');
  const [loginError, setLoginError] = useState('');

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
    });
    return () => unsubscribe();
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginError('');
    try {
      await signInWithEmailAndPassword(auth, loginEmail, loginPassword);
    } catch (err) {
      setLoginError('Invalid email or password');
    }
  };

  const handleLogout = () => {
    signOut(auth);
  };

  if (!user) {
    return (
      <div
        style={{
          minHeight: 400,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: 'Inter, Roboto, Arial, sans-serif',
          background: '#f7f9fc',
          borderRadius: 16,
          boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
          padding: '2rem 2.5rem',
          margin: '4rem auto',
          maxWidth: 400,
        }}
      >
        <h2 style={{ color: '#1976d2', marginBottom: '1.5rem' }}>Login</h2>
        <form onSubmit={handleLogin} style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <input
            type="email"
            placeholder="Email"
            value={loginEmail}
            onChange={e => setLoginEmail(e.target.value)}
            required
            style={{ padding: '0.75rem', fontSize: '1rem', borderRadius: 8, border: '1px solid #ccc' }}
          />
          <input
            type="password"
            placeholder="Password"
            value={loginPassword}
            onChange={e => setLoginPassword(e.target.value)}
            required
            style={{ padding: '0.75rem', fontSize: '1rem', borderRadius: 8, border: '1px solid #ccc' }}
          />
          <button
            type="submit"
            style={{
              background: 'linear-gradient(90deg, #1976d2 0%, #388e3c 100%)',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              padding: '0.75rem',
              fontWeight: 700,
              fontSize: '1.05rem',
              cursor: 'pointer',
            }}
          >
            Login
          </button>
          {loginError && <div style={{ color: 'red', marginTop: 8 }}>{loginError}</div>}
        </form>
      </div>
    );
  }

  return (
    <DbEntryDateProvider>
      <div
        style={{
          minHeight: 800,
          margin: '2rem auto',
          fontFamily: 'Inter, Roboto, Arial, sans-serif',
          background: '#f7f9fc',
          borderRadius: 16,
          boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
          padding: '2rem 2.5rem',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h1
            style={{
              textAlign: 'center',
              color: '#1976d2',
              fontWeight: 800,
              letterSpacing: '1px',
              marginBottom: '2.5rem',
              fontSize: '2.2rem',
            }}
          >
            <span style={{ color: '#388e3c' }}>{BRAND_NAME} Sales Report</span> Dashboard
          </h1>
          <button
            onClick={handleLogout}
            style={{
              background: '#fff',
              color: '#1976d2',
              border: '1px solid #1976d2',
              borderRadius: 8,
              padding: '0.5rem 1.2rem',
              fontWeight: 600,
              cursor: 'pointer',
              marginLeft: '2rem',
              marginTop: '1rem',
              height: '2.5rem'
            }}
          >
            Logout
          </button>
        </div>
        <nav
          style={{
            display: 'flex',
            gap: '1rem',
            marginBottom: '2.5rem',
            borderBottom: '2px solid #e0e3e7',
            justifyContent: 'center',
          }}
        >
          {TABS.map((tab, idx) => (
            <button
              key={tab.label}
              onClick={() => setActiveTab(idx)}
              style={{
                background: idx === activeTab
                  ? 'linear-gradient(90deg, #1976d2 0%, #388e3c 100%)'
                  : 'transparent',
                color: idx === activeTab ? '#fff' : '#1976d2',
                border: 'none',
                borderBottom: idx === activeTab ? '3px solid #388e3c' : 'none',
                padding: '0.75rem 2rem',
                cursor: 'pointer',
                fontWeight: idx === activeTab ? 700 : 500,
                borderRadius: '8px 8px 0 0',
                fontSize: '1.05rem',
                boxShadow: idx === activeTab ? '0 2px 8px rgba(56,142,60,0.08)' : 'none',
                transition: 'all 0.2s',
              }}
            >
              {tab.label}
            </button>
          ))}
        </nav>
        <div
          style={{
            background: '#fff',
            borderRadius: 12,
            boxShadow: '0 2px 8px rgba(25,118,210,0.04)',
            padding: '2rem',
            minHeight: '400px',
          }}
        >
          {TABS[activeTab].component}
        </div>
        <footer
          style={{
            marginTop: '2.5rem',
            textAlign: 'center',
            color: '#888',
            fontSize: '0.95rem',
          }}
        >
          &copy; {new Date().getFullYear()} SD Live Sales &mdash; Simply Dine
        </footer>
      </div>
    </DbEntryDateProvider>
  );
}

export default App;